import GenerateEmailContainer from './GenerateEmailContainer.js';
export default GenerateEmailContainer;